import { MessageToast } from '@sas/nova-commons/components/MessageToast';
import { usePopperRoot } from '@sas/nova-commons/hooks/usePopperRoot';
import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { useOnUnmount, useTimeout } from '../hooks';
import { useI18n } from '../../locale/I18nContext';
export function useMessageToast(options) {
    const { message, onDismiss, referenceElementRef } = options;
    // Dismiss the message when the parent component unmounts (maximize/restore/page-switch)
    useOnUnmount(() => {
        if (message) {
            onDismiss();
        }
    });
    const popperRoot = usePopperRoot();
    return popperRoot && message
        ? createPortal(React.createElement(TimedMessageToast, { message: message, onDismiss: onDismiss, referenceElementRef: referenceElementRef }), popperRoot)
        : null;
}
/**
 * MessageToast wrapper that calls onDismiss after 3 seconds unless the mouse is hovering over it.
 */
const TimedMessageToast = (props) => {
    const messageText = useI18n(props.message.text);
    const refMessageHovering = useRef('Outside');
    useTimeout(() => {
        if (refMessageHovering.current === 'Hovering') {
            refMessageHovering.current = 'HoveringExpired';
            return;
        }
        refMessageHovering.current = 'Outside';
        props.onDismiss();
    }, 3000);
    return (React.createElement(MessageToast, { onMouseEnter: () => (refMessageHovering.current = 'Hovering'), onMouseLeave: () => {
            if (refMessageHovering.current === 'HoveringExpired') {
                props.onDismiss();
            }
            refMessageHovering.current = 'Outside';
        }, referenceElementRef: props.referenceElementRef, displayMode: "primary", referenceElementDock: ['center', 'start'], toastDock: ['center', 'start'], isOpen: true }, messageText));
};
